module.exports = __webpack_public_path__ + "media/images/recruitment/designs/gamma-phi-bg-94ee8c03bee114774e2be0b121647adf.jpg";